<template>
  <div>
    <div class="booth_detail_content">
      <div class="detali_box">
        <div class="box_left">
          <div class="box_pic">
            <img
              v-if="booth.area === '美国'"
              class="ground"
              src="https://dcdn-jufair.jufair.com/service/apply_meiguobiaozhun.png"
              :alt="`${$t('booth.boothSampleGraph')}`"
              rel="nofollow,noindex" />
            <img
              v-else
              class="ground"
              src="https://dcdn-jufair.jufair.com/service/apply_biaozhun.jpeg"
              :alt="`${$t('booth.boothSampleGraph')}`"
              rel="nofollow,noindex" />
          </div>
          <div class="box_tag">
            <h3 class="tit">{{ $t('booth.standard_booth') }} {{ $t('booth.configuration') }}</h3>
            <div class="config">
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item1') }}</span>
              </div>
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item2') }}</span>
              </div>
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item3') }}</span>
              </div>
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item4') }}</span>
              </div>
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item5') }}</span>
              </div>
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item6') }}</span>
              </div>
              <div class="config_item">
                <span class="dot"></span>
                <span>{{ $t('booth.configInfo1.item7') }}</span>
              </div>
            </div>
            <div class="price">
              <span class="price_label">
                {{ $t('booth.standard_booth') }}{{ $t('booth.price') }}: {{ $t('booth.base') }}:
              </span>
              <span
                v-if="isLogin && booth && booth.boothPrice1 > 0"
                class="price_value">
                {{ booth.boothPrice1 || '' }}
              </span>
              <span
                v-else
                class="get-price"
                @click="handleLogin">
                {{ $t('booth.viewPrice') }}
              </span>
            </div>
            <div class="tip">{{ $t('booth.tip') }}</div>
          </div>
        </div>
        <div class="box_right">
          <div class="box_pic">
            <img
              class="ground"
              src="~/assets/images/apply-detailPic2.jpg"
              :alt="`${$t('booth.boothSampleGraph')}`"
              rel="nofollow,noindex" />
          </div>
          <div>
            <div class="box_tag">
              <h3 class="tit">{{ $t('booth.blank_booth') }} {{ $t('booth.configuration') }}</h3>
              <div class="config">
                <div class="config_item">
                  <span class="dot"></span>
                  <span>{{ $t('booth.configInfo2.item1') }}</span>
                </div>
                <div class="config_item">
                  <span class="dot"></span>
                  <span>{{ $t('booth.configInfo2.item2') }}</span>
                </div>
                <div class="config_item">
                  <span class="dot"></span>
                  <span>{{ $t('booth.configInfo2.item3') }}</span>
                </div>
              </div>
              <div class="price">
                <span class="price_label">
                  {{ $t('booth.blank_booth') }}{{ $t('booth.price') }}:
                </span>
                <span
                  v-if="isLogin && booth && booth.boothPrice2 > 0"
                  class="price_value">
                  {{ booth.boothPrice2 }}
                </span>
                <span
                  v-else
                  class="get-price"
                  @click="handleLogin">
                  {{ $t('booth.viewPrice') }}
                </span>
              </div>
              <div class="tip">{{ $t('booth.tip') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <template
      v-if="
        $get(booth, 'discounts', []) && $get(booth, 'discounts', []).length > 0
      "
    >
      <p class="discount_tit">展位折扣</p>
      <div class="discount_info">
        <div
          v-for="item in $get(booth, 'discounts', [])"
          :key="item.id"
          class="discount_info_bg"
        >
          <p>{{ item.endTime | dateFormat2 }}前预定享受</p>
          <p class="zhe">
            <span>{{ item.discount / 10 }}</span>
            折
          </p>
        </div>
      </div>
    </template> -->
    <div class="get_price_btn">
      <nuxt-link
        :to="`/exhibition/apply/${exhibitionId}.html`"
        :title="``"
        target="_blank">
        {{ $t('booth.viewFloorPrice') }}
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, inject } from 'vue'
  import type Login from '~/components/Login/index.vue'

  // 获取组件 props
  defineProps({
    booth: {
      type: Object,
      default: () => ({})
    },
    exhibitionId: {
      type: Number,
      default: 0
    }
  })

  const loginModal = inject('loginModal') as Ref<InstanceType<typeof Login>>

  // 使用 Vuex store
  const globalStore = useGlobalStore()

  // 计算属性，判断用户是否登录
  const isLogin = computed(() => globalStore.isLogin)

  // 处理登录逻辑
  function handleLogin() {
    loginModal.value?.open()
  }
</script>

<style lang="less" scoped>
  /* 展位价格 */
  .booth_detail_content {
    .detali_box {
      display: flex;

      .config {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .config_item {
          line-height: 1;
          padding: 6px 0;
          display: flex;
          align-items: center;
          margin-right: 8px;

          .dot {
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: @app-color;
            margin-right: 4px;
          }
        }
      }

      .box_left {
        border-radius: 4px;
        padding: 20px;
        width: 49%;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        margin-right: 10px;

        .box_pic {
          margin: auto;
          flex-shrink: 0;
          border-radius: 4px;
          overflow: hidden;

          > img {
            width: 377px;
            height: 232px;
            object-fit: contain;
          }
        }

        .box_tag {
          margin-top: 20px;

          .tit {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .price {
            font-size: 16px;
            color: #333;
            margin: 20px 0 6px;

            .price_value {
              color: @app-color;
            }

            .get-price {
              color: red;
            }
          }

          .tip {
            font-size: 14px;
            color: #aeaeae;
          }
        }
      }

      .box_right {
        border-radius: 4px;
        padding: 20px;
        width: 49%;
        margin-left: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

        .box_pic {
          flex-shrink: 0;
          border-radius: 4px;
          overflow: hidden;
          background: #d6d7de;

          > img {
            width: 377px;
            height: 232px;
            object-fit: contain;
          }
        }

        .box_tag {
          margin-top: 48px;

          .tit {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .price {
            font-size: 16px;
            color: #333;
            margin: 20px 0 6px;

            .price_value {
              color: @app-color;
            }
          }

          .tip {
            font-size: 14px;
            color: #aeaeae;
          }
        }
      }
    }
  }

  .discount_tit {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    line-height: 24px;
    margin-bottom: 16px;
  }

  .discount_info {
    display: flex;

    .discount_info_bg {
      width: 325px;
      height: 46px;
      margin-right: 36px;
      display: flex;
      background: url('assets/icon/quan.png') no-repeat;

      p {
        height: 20px;
        font-size: 16px;
        font-weight: 400;
        color: #63300f;
        line-height: 20px;
        margin-left: 50px;
        margin-top: 13px;
      }

      .zhe {
        margin-left: 40px;
        font-weight: normal;
        color: #fff;

        span {
          font-size: 30px;
        }
      }
    }
  }

  .get_price_btn {
    width: 350px;
    height: 37px;
    border-radius: 18px;
    border: 1px solid @app-color;
    color: @app-color;
    line-height: 37px;
    text-align: center;
    margin: 26px auto 40px;

    a {
      color: @app-color;
    }
  }
</style>
